<app-base-page [title]="ssoMode ? 'SSO Login' : 'Log In'">
    <div class="login">
        @if (!ssoMode) {
            <form [formGroup]="form" (ngSubmit)="login()" novalidate>
                <adc-input
                    type="email"
                    class="text-form-control block"
                    placeholder="E-mail address"
                    ariaLabel="E-mail address"
                    formControlName="email"
                    autocomplete="email"
                    [errorMessages]="emailErrorMessages"
                />

                <app-password-visibility>
                    <adc-input
                        #control
                        type="password"
                        class="text-form-control block"
                        placeholder="Password"
                        ariaLabel="Password"
                        formControlName="password"
                        autocomplete="current-password"
                        [errorMessages]="passwordErrorMessages"
                    />
                </app-password-visibility>

                @if (loginError?.message) {
                    <mat-error class="validation-message mt-10">
                        <mat-icon>warning</mat-icon>
                        <span>{{ loginError.message }}</span>
                    </mat-error>
                }
                <adc-checkbox
                    label="Remember this device for 60 days"
                    class="mt-24 login-remember"
                    formControlName="rememberMe"
                />

                <div class="actions">
                    <adc-button type="primary" size="40" class="submit-button" [isSubmit]="true" [disabled]="loading">
                        @if (loading) {
                            <mat-progress-bar mode="indeterminate" />
                        }
                        Login
                    </adc-button>

                    <div class="actions__links-row">
                        <a routerLink="/recover-password" class="adc-link adc-link--default">Forgot password?</a>

                        <span class="actions__divider-vertical"></span>

                        <a
                            href=""
                            class="adc-link adc-link--default actions__sso-link"
                            (click)="$event.preventDefault(); enterSsoMode()"
                        >
                            Log in with SSO
                        </a>
                    </div>
                </div>
            </form>
        } @else {
            <form [formGroup]="ssoForm" (ngSubmit)="ssoLogin()" novalidate>
                <adc-input
                    type="email"
                    class="text-form-control block"
                    placeholder="E-mail address"
                    ariaLabel="E-mail address"
                    formControlName="email"
                    autocomplete="email"
                    [errorMessages]="ssoEmailErrorMessages"
                />

                <adc-checkbox
                    label="Remember this device for 60 days"
                    class="mt-24 login-remember"
                    [formControl]="rememberMeControl"
                />

                <div class="actions">
                    <adc-button
                        type="primary"
                        size="40"
                        class="submit-button"
                        [isSubmit]="true"
                        [disabled]="ssoLoading"
                    >
                        @if (ssoLoading) {
                            <mat-progress-bar mode="indeterminate" />
                        }
                        Login
                    </adc-button>

                    <a
                        href=""
                        class="adc-link adc-link--default actions__sso-link"
                        (click)="$event.preventDefault(); exitSsoMode()"
                    >
                        Log in with password
                    </a>
                </div>
            </form>
        }
    </div>
</app-base-page>
